/* eslint-disable */

import 'bootstrap-datepicker';

/**
 * This is a wrapper around bootstrap-datepicker making use of django features.
 */
var DatePicker = (function($) {

    /**
     * We always use the current language (set by django) because
     * the translations are only available for the current language.
     * @type {String}
     */
    var language = $('html').attr('lang');

    /**
     * The current date, used for setting the minimum date.
     * @type {Date}
     */
    var now = new Date();

    /**
     * The defaults for the datepicker.
     * @type {Object}
     */
    var defaults = {
        todayHighlight: true,
        autoclose: true,
        startDate: now
    };

    /**
     * Whether or not to use the browsers build in date
     * picker. This is only useful for mobile devices.
     * @type {boolean}
     */
    var useNative = false;

    /**
     * An object with helper methods for formatting
     * and parsing dates defined by datepicker.
     */
    var dateHelper = $.fn.datepicker.DPGlobal;

    /**
     * A mapping of python/django date format directives
     * to format directives of the datepicker helper.
     * @type {Object}
     */
    var directives = {
        /* Python */
        a: 'D',
        A: 'DD',
        d: 'dd',
        b: 'M',
        B: 'MM',
        m: 'mm',
        y: 'yy',
        Y: 'yyyy',

        /* Django */
        j: 'd',
        F: 'MM',
        N: 'MM'  /* associated press style, not available in dateHelper therefore mapped to MM */
    };

    /**
     * Available date input formats defined
     * by django in the python format.
     * @type   {[String]}
     */
    var formats = get_format('DATE_INPUT_FORMATS');

    /**
     * The primary date input format in python
     * format mapped to the helper format.
     * @type {String}
     */
    var format = formats[0].replace(/%([aAdbBmyYjF])/g, function (match, directive) {
        return directives[directive];
    });

    var titleFormat = get_format('DATE_FORMAT').replace(/([jFYN])/g, function (match, directive) {
        return directives[directive];
    });

    $.fn.datepicker.dates[language] = {
        days: [
            gettext('Sunday'),
            gettext('Monday'),
            gettext('Tuesday'),
            gettext('Wednesday'),
            gettext('Thursday'),
            gettext('Friday'),
            gettext('Saturday')
        ],
        daysShort: [
            pgettext('weekday (short)', 'Sun'),
            pgettext('weekday (short)', 'Mon'),
            pgettext('weekday (short)', 'Tue'),
            pgettext('weekday (short)', 'Wed'),
            pgettext('weekday (short)', 'Thu'),
            pgettext('weekday (short)', 'Fri'),
            pgettext('weekday (short)', 'Sat')
        ],
        daysMin: [
            pgettext('weekday (brief)', 'Su'),
            pgettext('weekday (brief)', 'Mo'),
            pgettext('weekday (brief)', 'Tu'),
            pgettext('weekday (brief)', 'We'),
            pgettext('weekday (brief)', 'Th'),
            pgettext('weekday (brief)', 'Fr'),
            pgettext('weekday (brief)', 'Sa')
        ],
        months: [
            gettext('January'),
            gettext('February'),
            gettext('March'),
            gettext('April'),
            gettext('May'),
            gettext('June'),
            gettext('July'),
            gettext('August'),
            gettext('September'),
            gettext('October'),
            gettext('November'),
            gettext('December')
        ],
        monthsShort: [
            pgettext('month (short)', 'Jan'),
            pgettext('month (short)', 'Feb'),
            pgettext('month (short)', 'Mar'),
            pgettext('month (short)', 'Apr'),
            pgettext('month (short)', 'May'),
            pgettext('month (short)', 'Jun'),
            pgettext('month (short)', 'Jul'),
            pgettext('month (short)', 'Aug'),
            pgettext('month (short)', 'Sep'),
            pgettext('month (short)', 'Oct'),
            pgettext('month (short)', 'Nov'),
            pgettext('month (short)', 'Dec')
        ],
        today: gettext('Today'),
        clear: gettext('Clear'),
        monthsTitle: gettext('Months'),
        weekStart: +get_format('FIRST_DAY_OF_WEEK'),
        format: format,
        titleFormat: titleFormat
    };

    var DatePicker = function (input, options) {
        var node = this.node = input,
            jqNode = this.jqNode = $(node),
            configuration = $.extend({}, defaults, options);

        /* language can't be overridden because we only supply
           translations for the current language */
        configuration.language = language;

        if (useNative) {
            jqNode.attr('min', dateHelper.formatDate(now, 'yyyy-mm-dd', language));
        } else {
            jqNode
                .addClass('form-element')
                .prop('readonly', true)
                .attr('type', 'text')
                .attr('data-content', 'datepicker')
                .datepicker(configuration);
        }
    };

    DatePicker.prototype.update = function (value) {
        if (useNative) {
            this.jqNode.datepicker('update', value);
        } else if (value instanceof Date) {
            this.node.value = dateHelper.formatDate(value, 'yyyy-mm-dd', language);
        } else {
            this.node.value = value;
        }
    };

    DatePicker.prototype.getDate = function () {
        if (useNative) {
            return new Date(this.node.value);
        } else {
            return this.jqNode.datepicker('getDate');
        }
    };

    return DatePicker;
})(jQuery);

window.DatePicker = DatePicker;
